<template>
  <div class="flex flex-col justify-center">
    <div class="flex justify-center mt-10 sm:mt-20">
      <div class="max-w-64">
        <router-link :to="routeManager.homePath()" class="tmi-logo aspect-[4/1] h-20 block">
          <span class="sr-only">True Market Insiders</span>
        </router-link>
      </div>
    </div>
    <h2 v-if="authText" v-html="authText" class="text-center mt-4 font-light"></h2>
    <router-view name="loginSection" />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useRoute } from "vue-router";

import { useApplicationStore } from "@/stores/Application";
import routeManager from "@/router/route-manager";

const appStore = useApplicationStore();
const route = useRoute();

const loading = ref( false );
const authText = computed( () => routeManager.isSignInPath( route.path ) ? '' : 'Sign Up for <br /><span>Financial Freedom</span>' );

async function onLoginLikeAUser() {
  const token = `${ route.params.token }`;
  if ( !token ) {
    return null;
  }

  loading.value = true;
  try {
    appStore.authenticateWithToken( token ).then();
  } catch ( e ) {
    await appStore.resetApplication();
  } finally {
    loading.value = false;
  }
}

// Attempt token login when on the sign-in-as-user route
// This always runs regardless of current auth state to allow user switching
if ( routeManager.isSignInAsUserName( route.name?.toString() ) ) {
  onLoginLikeAUser().then();
}
</script>

<style>
a.tmi-logo {
  background-image: url("/img/logos/logo-green.svg");
  background-size: contain;
  background-repeat: no-repeat;
}

[data-theme="dark"] a.tmi-logo {
  background-image: url("/img/logos/logo-white.svg")
}
</style>
